import { SkaldValue } from '@skaldaura/devkit'
import Loader from 'components/loader/loader'
import { useCounterContext } from 'contexts/counter'
import { IPDF } from 'pages/salarie/projets/projets'
import { useEffect, useRef, useState } from 'react'
import './popup.scss'

interface IProps {
   pdf: IPDF
}

export default function SubgroupPopup({ pdf }: IProps) {
   const { counter, setCounter, counterDefault } = useCounterContext()
   const [paddingBottom, setPaddingBottom] = useState<number>(0)
   const [currentPage, setCurrentPage] = useState(1)
   const imageRefs = useRef<(HTMLImageElement | null)[]>([])
   const documentsRef = useRef<HTMLDivElement>(null)

   useEffect(() => {
      documentsRef?.current?.addEventListener('scroll', handleScroll)
      return () => {
         documentsRef?.current?.removeEventListener('scroll', handleScroll)
      }
   }, [])

   useEffect(() => {
         // appliquation d'un padding bottom pour que le haut du dernier élément soit aligné avec le haut de la fenêtre
         setPaddingBottom(
            1824 - (imageRefs.current[imageRefs.current.length - 1]?.clientHeight || 0) || 0,
         )
   }, [imageRefs.current.length])

   const handleImageRef = (index: number, ref: HTMLImageElement | null) => {
      imageRefs.current[index] = ref
   }

   const handleScroll = () => {
      if (counter !== counterDefault) setCounter(counterDefault)
      for (let i = 0; i < imageRefs.current.length; i++) {
         const image = imageRefs.current[i] as HTMLImageElement | null
         if (image) {
            const { top } = image.getBoundingClientRect()
            if (top < 10) {
               setCurrentPage(i + 1)
            }
         }
      }
   }

   const rendered =
      pdf.pages.length === 0 ? (
         <div id='loadingContainer' className='w-full h-full flex justify-center items-center '>
            <div className=''>
               <p className='text-white text-lg'>Chargement du document...</p>
               <Loader />
            </div>
         </div>
      ) : (
         pdf.pages.map((page: SkaldValue, index: number) => (
            <img
               ref={(ref) => handleImageRef(index, ref)}
               src={page.value}
               key={index + 1}
               className='object-contain w-full'
               alt=''
               id={`${index + 1}`}
            />
         ))
      )
   const pageBtns = pdf.pages.map((page: SkaldValue, index: number) => (
      <button
         key={index}
         className={`${index + 1 === currentPage ? 'active' : ''}`}
         onClick={() => {
            const ELEMENT = document.getElementById(`${index + 1}`)
            setCounter(counterDefault)
            if (ELEMENT) {
               ELEMENT.scrollIntoView({ behavior: 'smooth' })
            }
         }}
      >
         {index + 1}
      </button>
   ))
   return (
      <div
         ref={documentsRef}
         className={`subelement-popup ${pdf.pages.length === 1 && 'flex'}`}
         style={{ paddingBottom: `${paddingBottom}px` }}
      >
         {rendered}
         {pdf.pages.length > 1 && (
            <div id='btnContainer' className={`${pdf.pages.length > 0 || pageBtns.length > 18 ? 'ready' : ''}`}>
               <section>{pageBtns.length > 18 && '<'}</section>
               <div id='btns' className={`${pageBtns.length < 19 ? 'center' : 'start'}`}>
                  {pageBtns}
               </div>
               <section>{pageBtns.length > 18 && '>'}</section>
            </div>
         )}
      </div>
   )
}
